import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SecureCodeModifyComponent } from "./feature/codemodify/modify/secure-code-modify.component";
import { LoginComponent } from "./feature/codemodify/login/login.component";
import { SignComponent } from "./feature/codemodify/sign/sign.component";
import { PageNotFoundComponent } from "./component/page-not-found.component";
import { MaterialModule } from "./material/material.module";
import { ResourcesResolve } from "@core/resolve/resources.resolve";
import { SupportLinksResolve } from "@core/resolve/support-link.resolve";
import { StatusResolve } from "@core/resolve/status.resolve";


const routes: Routes = [
  {
    path: "",
    redirectTo: "/mkb3ds/login",
    pathMatch: "full"
  },
  {
    path: "",
    children: [
      {
      path: "mkb3ds",
      children: [
        { path: "login", component: LoginComponent },
        {
          path: "modify", component: SecureCodeModifyComponent,
          resolve: [ StatusResolve ]
        },
        {
          path: "sign", component: SignComponent,
          resolve: [ StatusResolve ]
        }
      ]}
    ],
    resolve: [
      ResourcesResolve,
      SupportLinksResolve
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    MaterialModule
  ],
  exports: [RouterModule],
  declarations: [
    PageNotFoundComponent
  ],
  providers: [
    ResourcesResolve,
    SupportLinksResolve,
    StatusResolve
  ]
})
export class AppRoutingModule { }
